/**
 * Veluna System Helper (TILE-10)
 * 
 * Lightweight system reporting for verification
 * No automatic logging - only reports when called
 * No PII - only reports system state, not user data
 */

(function() {
  'use strict';

  /**
   * Get current page type
   * @returns {string} - "collection" | "my_ritual" | "other"
   */
  function getPageType() {
    const path = window.location.pathname;
    if (path.includes('/collections/') || path === '/collections/all') {
      return 'collection';
    }
    if (path.includes('/pages/my-ritual') || path === '/pages/my-ritual') {
      return 'my_ritual';
    }
    return 'other';
  }

  /**
   * Get quiz state info (safe, no PII)
   * @returns {Object} - { present: boolean, outcome_handle: string|null, bundle_preference: string|null }
   */
  function getQuizInfo() {
    let quizState = null;
    try {
      if (window.VelunaQuizState && typeof window.VelunaQuizState.getQuizState === 'function') {
        quizState = window.VelunaQuizState.getQuizState();
      }
    } catch (e) {
      // Silently fail - module not available
    }

    if (!quizState) {
      return {
        present: false,
        outcome_handle: null,
        bundle_preference: null
      };
    }

    return {
      present: true,
      outcome_handle: quizState.outcome_handle || null,
      bundle_preference: quizState.bundle_preference || null
    };
  }

  /**
   * Get cart attributes info (safe, no network fetch)
   * @returns {Object} - { hasAttributes: boolean, keysPresent: string[] }
   */
  function getCartInfo() {
    // Check if Shopify cart object is available (no network fetch)
    if (typeof window.Shopify !== 'undefined' && window.Shopify.cart && window.Shopify.cart.attributes) {
      const attributes = window.Shopify.cart.attributes || {};
      const quizKeys = Object.keys(attributes).filter(key => key.startsWith('veluna_quiz_'));
      return {
        hasAttributes: quizKeys.length > 0,
        keysPresent: quizKeys
      };
    }

    // Fallback: check if cart data is in a known global
    if (typeof window.velunaCartData !== 'undefined' && window.velunaCartData.attributes) {
      const attributes = window.velunaCartData.attributes || {};
      const quizKeys = Object.keys(attributes).filter(key => key.startsWith('veluna_quiz_'));
      return {
        hasAttributes: quizKeys.length > 0,
        keysPresent: quizKeys
      };
    }

    return {
      hasAttributes: false,
      keysPresent: []
    };
  }

  /**
   * Get feature flags status
   * @returns {Object} - { collectionPersonalizationEnabled: boolean, browseMode: boolean }
   */
  function getFlagsInfo() {
    let collectionPersonalizationEnabled = false;
    try {
      // Check URL param
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('personalize') === '1') {
        collectionPersonalizationEnabled = true;
      } else {
        // Check localStorage
        if (localStorage.getItem('veluna_personalize_collection') === '1') {
          collectionPersonalizationEnabled = true;
        } else if (typeof window.VELUNA_COLLECTION_PERSONALIZATION !== 'undefined') {
          collectionPersonalizationEnabled = window.VELUNA_COLLECTION_PERSONALIZATION === true;
        }
      }
    } catch (e) {
      // Silently fail
    }

    let browseMode = false;
    try {
      browseMode = sessionStorage.getItem('veluna_browse_mode') === '1';
    } catch (e) {
      // Silently fail
    }

    return {
      collectionPersonalizationEnabled: collectionPersonalizationEnabled,
      browseMode: browseMode
    };
  }

  /**
   * Get My Ritual SSR state
   * @returns {Object} - { ssrState: "server"|"guest"|"client"|null }
   */
  function getMyRitualInfo() {
    const root = document.querySelector('[data-veluna-my-ritual-root]');
    if (!root) {
      return { ssrState: null };
    }

    const state = root.getAttribute('data-veluna-my-ritual-state');
    return {
      ssrState: state || null
    };
  }

  /**
   * Generate system report
   * @returns {Object} - Complete system report
   */
  function report() {
    return {
      path: window.location.pathname,
      pageType: getPageType(),
      quiz: getQuizInfo(),
      cart: getCartInfo(),
      flags: getFlagsInfo(),
      myRitual: getMyRitualInfo()
    };
  }

  // Expose API to window (only when called, no auto-logging)
  window.VelunaDiagnostics = {
    report: report
  };

})();



/* ===== VELUNA CTA FIX - injected via diagnostics ===== */
(function(){
  if (document.getElementById('veluna-cta-color-fix')) return;
  var s = document.createElement('style');
  s.id = 'veluna-cta-color-fix';
  s.textContent = [
    '.article__content .veluna-cta-block p,',
    '.article__content .veluna-cta-block span,',
    '.article__content .veluna-cta-block strong {',
    '  color: #fff4e4 !important;',
    '  font-family: Georgia, "Times New Roman", serif !important;',
    '  font-size: 1.2rem !important;',
    '  line-height: 1.72 !important;',
    '}',
    '.j-card__title, .blog-card__title, .article-grid__title, .blog-post__title {',
    '  font-family: "Iowan Old Style","Palatino Linotype","Book Antiqua",Georgia,serif !important;',
    '}',
    '.j-card__excerpt, .blog-card__excerpt, .article-grid__excerpt, .blog-post__excerpt {',
    '  font-family: Georgia, "Times New Roman", serif !important;',
    '  color: #5a5048 !important;',
    '}'
  ].join('\n');
  document.head.appendChild(s);
})();
/* ===== END VELUNA CTA FIX ===== */
